import { redirect } from "react-router-dom";
import { switchAccount, getCurrentUser } from "../data/auth.service";
import { getMapping } from "../routes/ModulesMapping";
import { send, notify } from "../services/NotificationService";

export async function loader({ params }) {

    var s = await switchAccount(params.childId);
    if (s && s.status === 500) {
        send("warning", s.message)
        notify();
    }
   

    var host = window.location.host
    var subdomain = host.split('.')[0]


    let user = getCurrentUser();
    if ((user && user.roles) || subdomain === "location") {
        var loc = getMapping(user.roles[0]);
        return redirect(loc);
    }
    return redirect(`/login`);
    
}